import { AIDE_ET_CONTACT_TABS, changerTab } from '../../../pages/aide-et-contact/main';
import MicroApp from './micro-app-base';

/**
 * Microapp aide et contact
 */
export default class AideEtContactMicroApp extends MicroApp {
  /**
   * Changement de l'onglet dans le portail via un message Pym
   */
  childPymEvents = {
    changementTabUser: function (tab) {
      if (tab === 'demandes-en-ligne') {
        changerTab(AIDE_ET_CONTACT_TABS.demandesEnLigne);
        window.scroll(0, 0);
      }
    }.bind(this),
  };
}
